// ABOUTME: Renders a "linked / unlinked" activity pill for a chat update.
// ABOUTME: Type-colored chip on the right; red gradient overlay and strikethrough for removals.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import Text from "../../../../../../../components/theme/text/Text";
import { tokens } from "../../../../../../../theme";
import {
    generateColorFromTitle,
    generateIconColorFromTitle,
} from "../../../../../../../components/theme/TabView3/IconColorGenerator";
import { search_keys } from "../../../../../../../utils/searchKeys";
import { support_ticket_linked_type_to_search_key } from "../../../../../../../utils/staticEnums";

const MessageTypeLinkedItem = ({ update }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const linked = update.linkedItem || {};
    const reference = linked.displayReference;
    const name = linked.displayName;
    if (!reference && !name) return null;

    const isRemoved = update.type === 'linked_item_removed';
    const linkedType = linked.linkedType || '';
    const typeBg = generateColorFromTitle(linkedType, theme.palette.mode, 90);
    const typeFg = generateIconColorFromTitle(linkedType, theme.palette.mode);
    const gradientStop = generateColorFromTitle(linkedType, theme.palette.mode, 75);
    const iconBoxFill = generateColorFromTitle(linkedType, theme.palette.mode, 95);
    const searchKey = support_ticket_linked_type_to_search_key[linkedType];
    const icon = linkedType === "webshopcredentials"
        ? <StoreOutlinedIcon sx={{ fontSize: 14 }} />
        : search_keys[searchKey]?.icon;

    return (
        <Box
            sx={{
                height: 40,
                borderRadius: 5,
                background: isRemoved
                    ? `linear-gradient(to right, ${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0]} -15%, ${colors.red[200]} 150%), ${theme.palette.mode === "dark" ? "black" : "white"}`
                    : `linear-gradient(to right, ${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0]} -15%, ${gradientStop} 150%), ${theme.palette.mode === "dark" ? "black" : "white"}`,
                border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                pr: 0.5,
                pl: 2,
                display: "flex",
                alignItems: 'center',
                justifyContent: "space-between",
                gap: 1.5,
            }}
        >
            <Text noBreak fontSize={13}>
                {t(isRemoved ? "item_unlinked_from_ticket" : "item_linked_to_ticket")}
            </Text>
            <Box
                sx={{
                    flexShrink: 0,
                    height: 32,
                    pl: 0.5,
                    pr: 2,
                    borderRadius: 4,
                    background: typeBg,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    maxWidth: "70%",
                    overflow: "hidden",
                    textDecoration: isRemoved ? "line-through" : "none",
                }}
            >
                <Box
                    sx={{
                        borderRadius: 4,
                        height: 24,
                        width: 24,
                        flexShrink: 0,
                        background: typeFg,
                        color: iconBoxFill,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        "& svg": { fontSize: 14 },
                        "& svg path": { fill: iconBoxFill },
                    }}
                >
                    {icon}
                </Box>
                {reference && (
                    <Text bold fontSize={13} noBreak>{reference}</Text>
                )}
            </Box>
        </Box>
    );
};

export default MessageTypeLinkedItem;
